import { z } from 'zod'
import { businessDateSchema, paginatedSchema, paginationQuerySchema } from './common.ts'

/**
 * Dates are plain calendar dates in Asia/Jakarta. The server widens them into
 * the correct instant range for LiteLLM, so "last 7 days" means the same thing
 * to a user in Jakarta as it does to the database.
 */
export const usageQuerySchema = paginationQuerySchema.extend({
  startDate: businessDateSchema,
  endDate: businessDateSchema,
})

export type UsageQuery = z.infer<typeof usageQuerySchema>

export const usageStatusSchema = z.enum(['success', 'failure'])

export type UsageStatus = z.infer<typeof usageStatusSchema>

export const usageLogSchema = z.object({
  requestId: z.string(),
  model: z.string(),
  status: usageStatusSchema,
  promptTokens: z.number().int(),
  completionTokens: z.number().int(),
  totalTokens: z.number().int(),
  spendUsd: z.number(),
  startedAt: z.string(),
  endedAt: z.string(),
  durationMs: z.number(),
  errorMessage: z.string().nullable(),
})

export type UsageLog = z.infer<typeof usageLogSchema>

export const usageLogPageSchema = paginatedSchema(usageLogSchema)

export type UsageLogPage = z.infer<typeof usageLogPageSchema>
